import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { onResponse, onSubmit } from "../../interview/handlers"
import * as interviewActions from "../../interview/actions"

import Header from "./Header"
import Question from "./Question"
import SubmitButton from "../../interview/components/SubmitButton"
import FilterCard, { CloseIcon } from "./FilterCard"

const Clarifier = props => (
  <React.Fragment>
    <FilterCard clarifier {...props}>
      {!props.customSymptom && (
        <CloseIcon
          onClick={props.onClose}
        />
      )}
      <Header
        text={props.symptomText}
        onRemove={props.onRemove}
        hideRemove={props.customSymptom}
      />
      <Question
        key={props.item.token}
        item={props.item}
        last
        onResponse={props.onResponse(props.item)}
      />
    </FilterCard>
    <SubmitButton
      margin="0 0 32px"
      disabled={!props.item.response.filter(r => !r.preselected).length > 0}
      count={props.item.response.filter(r => !r.preselected).length}
      onSubmit={props.onSubmit(props.item)}
    >
      Submit
    </SubmitButton>
  </React.Fragment>
)

Clarifier.propTypes = {
  onResponse: PropTypes.func.isRequired,
  symptomText: PropTypes.string,
  valid: PropTypes.bool,
}

const mapStateToProps = state => ({
  symptomText: state.search.header.filter,
  loading: state.loading,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onResponse: item => onResponse(item, dispatch),
  onClose: () => dispatch(interviewActions.triggerEdit(ownProps.index, true, false)),
  onRemove: () => dispatch(interviewActions.triggerEdit(ownProps.index, true)),
  onSubmit: item => onSubmit(item, dispatch),
})

const ClarifierWrapper = connect(mapStateToProps, mapDispatchToProps)(Clarifier)

export { ClarifierWrapper as default, Clarifier }



// WEBPACK FOOTER //
// ./assets/filters/components/ClarifierBubble.js